import { useEffect, useState } from 'react';
import { useDiscover } from '../../lib/discover.js';
import { shortAddr } from '../../lib/fmt.js';
import { TokenLogo } from '../TokenTicker.js';

/**
 * Full-page loading state for a token map. Names the token being loaded
 * (from the discover lists when we know it) so nobody mistakes it for the
 * previous token, and shows which step is running.
 */
export function TokenLoading({ address, what = 'map' }: { address: string; what?: 'map' }) {
  const { data } = useDiscover();
  const known = data && [...data.popular, ...data.live].find((t) => t.address === address);
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    setSecs(0);
    const t = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [address]);
  const step = secs < 4 ? 0 : secs < 12 ? 1 : 2;
  const steps = ['Reading every holder', 'Measuring who holds what', 'Drawing the map'];
  void what;
  return (
    <div className="tl" role="status" aria-live="polite">
      <div className="tl-card">
        <div className="tl-token">
          {known ? <TokenLogo t={known} size={44} /> : <span className="tl-logo-ph" aria-hidden="true" />}
          <div>
            <em>Loading</em>
            <b>{known ? known.symbol : shortAddr(address, 4, 4)}</b>
            <span className="mono">{shortAddr(address, 6, 6)}</span>
          </div>
        </div>
        <div className="tl-bar" aria-hidden="true">
          <i style={{ width: `${Math.min(92, 8 + secs * (secs < 10 ? 7 : 2))}%` }} />
        </div>
        <ol className="tl-steps">
          {steps.map((s, i) => (
            <li key={s} className={i < step ? 'done' : i === step ? 'on' : ''}>
              <span className="tl-dot">{i < step ? '✓' : i === step ? <span className="spinner" /> : ''}</span>
              {s}
            </li>
          ))}
        </ol>
        <p className="tl-note">
          {secs < 15
            ? 'Large tokens with many holders take longer the first time. Linked wallets keep filling in after the map appears.'
            : 'Still reading. Tokens with hundreds of thousands of holders can take up to a minute the first time; after that they open instantly.'}
        </p>
      </div>
    </div>
  );
}
